import type { ViewerRowColor } from '@/modules/viewer/types/row-color.type.ts';
import { ColorCode } from '@/modules/core/enums/color-code.enum.ts';

export const ROW_COLOR_MAP: Record<ColorCode, ViewerRowColor> = {
  [ColorCode.None]: 'light-gray',
  [ColorCode.Gray]: 'gray',
  [ColorCode.Yellow]: 'yellow',
  [ColorCode.Red]: 'red',
  [ColorCode.Green]: 'green',
  [ColorCode.Blue]: 'blue',
  [ColorCode.Purple]: 'purple',
};
